import { Helmet } from "react-helmet-async";

const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=1200&q=80";

export default function SEO({
  title,
  description = "Hope For All Organizations (HOFA) — a Liberian humanitarian nonprofit weaving Education, Research, Social Engagement, Economic Empowerment, and Health Services into lasting community change since 2015.",
  image = DEFAULT_IMAGE,
  path = "",
  type = "website",
}) {
  const fullTitle = title ? `${title} — HOFA` : "HOFA — Hope For All Organizations | Brewerville, Liberia";
  const url = typeof window !== "undefined" ? `${window.location.origin}${path || window.location.pathname}` : path;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="HOFA" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
